import config from '../../../../config'
export default {
  components: {},
  name: 'Footer',
  data () {
    return {
      sections: config.sections
    }
  },
  computed: {
  },
  mounted () {
  },
  methods: {

    onI18nChangeState (value) {
    }
  }
}
